import { createStore, combineReducers, compose } from "redux";
import firebase from "firebase";
import "firebase/firestore/dist/index.cjs";
import { reactReduxFirebase, firebaseReducer } from "react-redux-firebase";
import { reduxFirestore, firestoreReducer } from "redux-firestore";

import notifyReducer from "./reducers/notifyReducer";
import settingsReducer from "./reducers/settingsReducer";

const firebaseConfig = {
  apiKey: "AIzaSyCGqNNHGlDo81zJOe2HNwgjVLdgd-rsWPw",
  authDomain: "rcrm-4b05b.firebaseapp.com",
  databaseURL: "https://rcrm-4b05b.firebaseio.com",
  projectId: "rcrm-4b05b",
  storageBucket: "rcrm-4b05b.appspot.com",
  messagingSenderId: "196267364181"
};

const rrfConfig = {
  userProfile: "users",
  useFirestoreForProfile: true
};

firebase.initializeApp(firebaseConfig);
const firestore = firebase.firestore();
const settings = { timestampsInSnapshots: true };
firestore.settings(settings);

const createStoreWithFirebase = compose(
  reactReduxFirebase(firebase, rrfConfig),
  reduxFirestore(firebase)
)(createStore);

const rootReducer = combineReducers({
  firebase: firebaseReducer,
  firestore: firestoreReducer,
  notify: notifyReducer,
  settings: settingsReducer
});

if (
  localStorage.getItem("settings") === null ||
  localStorage.getItem("settings") === undefined
) {
  const defaultSettings = {
    disableBalanceOnAdd: true,
    disableBalanceOnEdit: false,
    allowRegistration: true
  };

  console.log("aaaa");

  localStorage.setItem("settings", JSON.stringify(defaultSettings));
}

const initialState = { settings: JSON.parse(localStorage.getItem("settings")) };

const store = createStoreWithFirebase(
  rootReducer,
  initialState,
  compose(
    reactReduxFirebase(firebase),
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  )
);

export default store;



// WEBPACK FOOTER //
// ./src/store.js